var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AppConditionalWrapper',{attrs:{"name":_vm.block.data.useContainer ? 'AppContainer' : null}},[_c(_vm.resolvedComponent,{tag:"Component",staticClass:"app-content-block",attrs:{"uid":_vm.block.id,"data":_vm.normalizedBlockData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }